import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/list/:category_id?",
    name: "list",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/HomeList.vue"),
  },
  {
    path: "/zhuying",
    name: "zhuying",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/HomeZhuying.vue"),
  },
  {
    path: "/xm",
    name: "xm",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/HomeProjectDetail.vue"),
  },
  {
    path: "/project",
    name: "project",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/HomeProject.vue"),
  },
  {
    path: "/detail",
    name: "detail",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/HomeDetail.vue"),
  },
  {
    path: "/about",
    name: "about",
    redirect: "/about/gaikuang",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/HomeAbout.vue"),
    children: [
      {
        path: "gaikuang",
        name: "gaikuang",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/about/AboutGaikuang.vue"
          ),
      },
      {
        path: "chuangshiren",
        name: "chuangshiren",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/about/AboutChuangshiren.vue"
          ),
      },
      {
        path: "wenhua",
        name: "wenhua",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/about/AboutWenhua.vue"
          ),
      },
      {
        path: "rongyu",
        name: "rongyu",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/about/AboutRongyu.vue"
          ),
      },
      {
        path: "licheng",
        name: "licheng",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/about/AboutLicheng.vue"
          ),
      },
    ],
  },
  {
    path: "/party/detail/:id",
    name: "detail",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/party/PartyDetail.vue"),
  },
  {
    path: "/party",
    name: "party",
    redirect: "/party/dongtai",
    component: () =>
      import(/* webpackChunkName: "party" */ "../views/HomeParty.vue"),
    children: [
      {
        path: "dongtai",
        name: "dongtai",
        component: () =>
          import(
            /* webpackChunkName: "party" */ "../views/party/PartyDongtai.vue"
          ),
      },
      {
        path: "news",
        name: "news",
        component: () =>
          import(
            /* webpackChunkName: "party" */ "../views/party/PartyNews.vue"
          ),
      },
      {
        path: "jianshe",
        name: "jianshe",
        component: () =>
          import(
            /* webpackChunkName: "party" */ "../views/party/PartyJianshe.vue"
          ),
      },
    ],
  },
  {
    path: "/join",
    name: "join",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/HomeJoin.vue"),
  },
  {
    path: "/joindetail",
    name: "joindetail",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/HomeJoindetail.vue"),
  },
  {
    path: "/joinsubmit/:id",
    name: "joinsubmit",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/HomeJoinsubmit.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/HomeContact.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
